<template lang="html">

  <footer class="footer"  v-if="$route.name != 'proximamente'">

    <div class="top row-between container">
      <div class="left row-start">
        <a :href="$t('link footer 1')" target="_blank"><img :src="$t('imagen footer 1')" alt="Diputación Jaén"></a>
        <a :href="$t('link footer 2')" target="_blank"><img :src="$t('imagen footer 2')" alt="Jaén Paraiso Interior"></a>
      </div>
      <div class="right row-end">
        <router-link v-for="(categoria,key) in categorias" :key="key" v-if="categoria.visible == 1 && categoria.logo.url" :to="$t('enlaces.categoria')+'/'+categoria.slug"><img v-if="categoria.logo" :src="categoria.logo.url" :alt="categoria.name"></router-link>        
      </div>
    </div>

    <div class="bottom container row-between">
      <a :href="`tel:${$t('Teléfono información')}`" class="mas-info">{{$t('Más información')}}: {{$t('Teléfono información')}}</a>
      <div class="followus row-start">
        <h2>Síguenos</h2>
        <a href="https://www.instagram.com/jaenturismo_/" target="_blank"><i class="fa fa-instagram"></i>instagram</a>
        <a href="https://www.facebook.com/turismoprovinciajaen" target="_blank"><i class="fa fa-facebook"></i>facebook</a>
        <a href="https://twitter.com/jaenturismo" target="_blank"><i class="fa fa-twitter"></i>twitter</a>
      </div>
      <nav class="links row-center">
        <a :href="$t('link pie 1')" target="_blank">{{$t('texto pie 1')}}</a>
        <a :href="$t('link pie 2')" target="_blank">{{$t('texto pie 2')}}</a>
        <a :href="$t('link pie 3')" target="_blank">{{$t('texto pie 3')}}</a>
        <a :href="$t('link pie 4')" target="_blank">{{$t('texto pie 4')}}</a>
        <router-link to="/mapa-web">Mapa web</router-link>
        <a href="https://www.jaenparaisointerior.es/web/jaen-paraiso-interior/politica-privacidad" target="_blank">Política de privacidad</a>
        <a href="/accesibilidad">Accesibilidad</a>
      </nav>
    </div>

  </footer>

</template>

<script lang="js">


  import {mapGetters} from 'vuex'

  export default  {
    name: 'app-footer',
    computed:{
      ...mapGetters({
        version : 'getVersion',
        categorias : 'getCategorias'
      })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/parts/footer.vue